import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { CUSTOMER_TRAVELPLAN } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { getSanctumBearerToken } from '~/helpers/sanctumAuth';
import { CustomerTravelplanRequest, CustomerTravelplanResponse } from '~/types/api';
import { MutationError } from '~/types/form';
import { CustomerTravelplanRequestSchema, CustomerTravelplanResponseSchema } from '~/validation/api/customerTravelplanResponse';

export const getCustomerTravelplan = async (obj: CustomerTravelplanRequest) => {
  const body = CustomerTravelplanRequestSchema.parse(obj);

  try {
    const api = CUSTOMER_TRAVELPLAN.replace(':travelplanId', body.travelplan_id.toString());

    const response = await axios.post(api, body, {
      headers: {
        Authorization: getSanctumBearerToken(),
      },
    });

    const json = response.data;

    return CustomerTravelplanResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export function useCustomerTravelplan(obj: CustomerTravelplanRequest) {
  return useQuery<CustomerTravelplanResponse, MutationError>({
    queryKey: ['customerTravelplan', obj.travelplan_id],
    queryFn: () => {
      return getCustomerTravelplan(obj);
    },
    retry: false,
  });
}
